import { nextTick, ref, toValue, type MaybeRefOrGetter } from 'vue'
import { jobApi } from '@/services/api'

/**
 * @deprecated use useInfinityJob instead
 *
 */
export const useInfiniteJob = ({ values = ref([]), limit = ref(10), page = ref(1) }) => {
  // <b-autocomplete-infity class="w-full" @get-more-data="getMoreResources" :list="resourceAutoComplete.list"
  // :selected="project.contributors" @add-selected="addSalesContributor"
  // @remove-selected="removeSalesContributor"
  // :haveMore="resourceAutoComplete.haveMore && !resourceAutoComplete.loading">
  // <template #custom-list="{ selectItem, list }">
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    const officeIndex = values.value.findIndex(job => job._id === selected._id)
    if (officeIndex > -1)
      return values.value.splice(officeIndex, 1)
    values.value.push(selected)
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 1
      haveMore.value = true
    }
    loading.value = true
    const jobRequest = await jobApi.getFilter({ page: page.value, limit: limit.value, search: options.search }).promise
    loading.value = false
    haveMore.value = jobRequest.count.currentPage < jobRequest.count.totalPages
    list.value = options.new ? jobRequest.docs : [...list.value, ...jobRequest.docs]
    page.value++
  }

  const remove = (toRemove) => {
    const foundIndex = values.value.findIndex(job => job._id === toRemove._id)
    if (foundIndex === -1)
      return

    values.value.splice(foundIndex, 1)
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    values,
  }
}

export const useInfinityJob = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), onlyStaffing = false, firmId = undefined, jobCategories = undefined as MaybeRefOrGetter<string[]> | undefined }) => {
  const haveMore = ref(true)
  const total = ref(0)
  const getMoreData = async () => {
    try {
      isLoading.value = true

      // Only the grades of these grade categories, when some are given
      const jobCategoryIds = toValue(jobCategories)
      const searchRequest = jobApi.filter({ search: search.value, limit: limit.value, page: page.value, onlyStaffing, firmId, ...(jobCategoryIds?.length ? { jobCategories: jobCategoryIds } : {}) })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage

      await nextTick() // to be sure have more is updated so the request won't be done again

      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]

      total.value = searchResponse.count.total;

      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
    total
  }
}
